import { HashMap } from '@jsverse/transloco';

/**
 * Message à traduire au rendu (clé transloco + paramètres). Les erreurs de l'onglet Configuration
 * sont gardées sous cette forme plutôt que traduites à la création : le service et le composant
 * n'ont pas à injecter `TranslocoService`, et le texte suit un changement de langue.
 */
export interface ConfigMessage {
  key: string;
  params?: HashMap;
}

/** Erreur affichée : clé à traduire, ou message brut du backend (déjà rédigé côté serveur). */
export type ConfigError = ConfigMessage | string;

/** Fonction `t` exposée par la directive structurelle `*transloco`. */
export type TranslateFn = (key: string, params?: HashMap) => string;

export function configMessage(key: string, params?: HashMap): ConfigMessage {
  return params ? { key, params } : { key };
}

/** Texte d'une erreur : le message brut tel quel, la clé traduite avec ses paramètres. */
export function renderConfigError(err: ConfigError, t: TranslateFn): string {
  return typeof err === 'string' ? err : t(err.key, err.params);
}
